const routers = [
    { path: '/admin', name: "后台登录页", component: () => import("@/components/after-web/Login") },
    {
        path: '/admin/home',
        component: () => import("@/components/after-web/Home"),
        name: "主页",
        children: [
            {
                path: '/admin/homePage',
                name: "网站首页",
                component: () => import("@/components/after-web/homePage"),
                meta: [
                    { name: '网站首页',url: '/homePage'},
                ]
            },
            {
                path: '/admin/scopeInfo',
                name: "标题内容",
                component: () => import("@/components/after-web/scopeInfo"),
                meta: [
                    { name: '标题内容',url: '/admin/scopeInfo'},
                ]
            },
            {
                path: '/admin/scopeDetail',
                name: "范围内容",
                component: () => import("@/components/after-web/scopeDetail"),
                meta: [
                    { name: '范围内容',url: '/admin/scopeDetail'},
                ]
            },
            {
                path: '/admin/serviceInfo',
                name: "服务内容",
                component: () => import("@/components/after-web/serviceInfo"),
                meta: [
                    { name: '服务内容',url: '/admin/serviceInfo'},
                ]
            },
            {
                path: '/admin/cartList',
                name: "合作伙伴",
                component: () => import("@/components/after-web/cartList"),
                meta: [
                    { name: '合作伙伴',url: '/admin/cartList'},
                ]
            },
        ]
    },
    {
        path: '/',
        name: "前台首页",
        component: () => import("@/components/front-web/home"),
    }


]

export default routers
